export default function Footer() {
    let date = new Date().getFullYear()
    return (
        <div className="bg-canol-sandy sticky bottom-0 z-50 shadow-lg">
            <p className="text-center text-sm">Designed by <a href="mailto: mlawes@gmail.com">Meriadoc Lawes</a></p>
            <p className="text-center text-sm">&copy;{date} Canol Music. All rights reserved.</p>
        </div>
    )
}